/**
 * Contract addresses by chain ID for Uniswap V4 / Clanker integration.
 *
 * Story 5.1 Task 2 — Base (8453) addresses are live; 0G Testnet (16600) placeholders TBD.
 * ARCH-24: Chain config is environment-driven.
 */

type ChainAddresses = {
	poolManager: `0x${string}`;
	universalRouter: `0x${string}`;
	stateView: `0x${string}`;
	quoter: `0x${string}`;
	permit2: `0x${string}`;
	weth: `0x${string}`;
};

const BASE_ADDRESSES: ChainAddresses = {
	poolManager: "0x498581fF718922c3f8e6A244956aF099B2652b2b",
	universalRouter: "0x6fF5693b99212Da76ad316178A184AB56D299b43",
	stateView: "0xA3c0c9b65baD0b08107Aa264b0f3dB444b867A71",
	quoter: "0x0d5e0f971ed27fbff6c2837bf31316121532048d",
	permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
	weth: "0x4200000000000000000000000000000000000006",
};

// 0G Testnet (16600) addresses are TBD — will be added once V4 contracts are deployed.
// DO NOT add zero-address placeholders: they would silently send funds to the burn address.

const CHAIN_ADDRESSES: Record<number, ChainAddresses> = {
	8453: BASE_ADDRESSES,
};

/**
 * All Clanker pools use dynamic fees — fee field in the pool key.
 */
export const DYNAMIC_FEE_FLAG = 0x800000;

/**
 * Default tick spacing for Clanker V4 pools.
 * The SDK defaults to 200 (see clankerTokenV4.ts tickSpacing z.number().default(200)).
 */
export const CLANKER_TICK_SPACING = 200;

/**
 * Get contract addresses for a given chain ID.
 * Returns Base addresses for chain 8453, 0G Testnet placeholders for 16600.
 * Returns undefined if chain ID is unsupported.
 */
export function getChainAddresses(chainId: number): ChainAddresses | undefined {
	return CHAIN_ADDRESSES[chainId];
}
